(ns journal-app-client.modals.filter-state-selection
  (:require [journal-app-client.components.button :as button]
            [journal-app-client.components.input :as input]
            [journal-app-client.utils.formatting :as fmt]
            [clojure.string :as s]
            [re-frame.core :as rf]
            [journal-app-client.components.modal :as m]
            [journal-app-client.utils.react :refer [use-state]]))

(defn main-fn [id props]
  (let [organizations nil
        sorted-organizations (sort-by #(get-in (second %) [:information :name] "Unnamed") organizations)
        regions nil
        sorted-regions (sort-by #(get-in (second %) [:information :name] "Unnamed") regions)
        venues nil
        sorted-venues (sort-by #(get-in (second %) [:information :name] "Unnamed") venues)
        sorted-venues (filter #(not (:archived-ts (second %))) sorted-venues)
        filter-state nil
        [state set-state] (use-state (assoc filter-state :search ""))]
    [:<>
     [m/body
      [:div.box
       {:style {:position "sticky"
                :top      "0"
                :z-index  "2"}}
       [:h1.title.is-4 "Filter venues"]
       [input/input
        {:placeholder "Search"
         :auto-focus  true
         :value       (:search state)
         :on-change   #(set-state (assoc state :search (-> % .-target .-value)))}]]
      #_(when (and (empty? sorted-organizations) (empty? sorted-regions) (empty? sorted-venues))
        [:div.box
         [:p.subtitle
          {:style {:color "var(--warning)"}}
          "You have no access to any organizations, regions or venues."]])
      [:div.tile.is-ancestor
       [:div.tile.is-vertical.is-12
        [:div.tile
         #_(when-not (empty? sorted-organizations)
           [:div.tile.is-parent.is-vertical
            (into
              [:div.box.tile.is-child [:p.subtitle "Organizations"]]
              (map-indexed
                (fn [index data]
                  (let [id (first data)
                        name (get-in (second data) [:information :name] "Unnamed")]
                    [button/button
                     {:key      (str id)
                      :class    (str (if (contains? (:organizations state) id)
                                       " is-success "
                                       " is-outlined ")
                                     " is-fullwidth fade-in ")
                      :style    {:display (when-not (s/includes? (fmt/lower-case name) (fmt/lower-case (:search state))) "none")
                                 :margin  (when (= index (dec (count organizations))) "0")}
                      :on-click (fn []
                                  (set-state (assoc state :organizations
                                                    (if (contains? (:organizations state) id)
                                                      (disj (:organizations state) id)
                                                      (conj (:organizations state) id)))))}
                     name]))
                sorted-organizations))])
         #_(when-not (empty? sorted-regions)
           [:div.tile.is-parent.is-vertical
            (into
              [:div.box.tile.is-child [:p.subtitle "Regions"]]
              (map-indexed
                (fn [index data]
                  (let [id (first data)
                        name (get-in (second data) [:information :name] "Unnamed")]
                    [button/button
                     {:key      (str id)
                      :class    (str (if (contains? (:regions state) id)
                                       " is-success "
                                       " is-outlined ")
                                     " is-fullwidth fade-in ")
                      :style    {:display (when-not (s/includes? (fmt/lower-case name) (fmt/lower-case (:search state))) "none")
                                 :margin  (when (= index (dec (count regions))) "0")}
                      :on-click (fn []
                                  (set-state (assoc state :regions
                                                    (if (contains? (:regions state) id)
                                                      (disj (:regions state) id)
                                                      (conj (:regions state) id)))))}
                     name]))
                sorted-regions))])]
        (if (empty? sorted-venues)
          [:div.box [:p.subtitle {:style {:color "var(--warning)"}} "You have no access to any venues."]]
          [:div.tile.is-parent.is-vertical
           (into
             [:div.box.tile.is-child
              [:p.subtitle (if (empty? (:venues state))
                             "Venues"
                             (str "Venues, " (count (:venues state)) " selected"))]]
             (map-indexed
               (fn [index data]
                 (let [id (first data)
                       name (get-in (second data) [:information :name] "Unnamed")]
                   [button/button
                    {:key      (str id)
                     :class    (str (if (contains? (:venues state) id)
                                      " is-success "
                                      " is-outlined ")
                                    " is-fullwidth fade-in ")
                     :style    {:display (when-not (s/includes? (fmt/lower-case name) (fmt/lower-case (:search state))) "none")
                                :margin  (when (= index (dec (count venues))) "0")}
                     :on-click (fn []
                                 (set-state (assoc state :venues
                                                   (if (contains? (:venues state) id)
                                                     (disj (:venues state) id)
                                                     (conj (:venues state) id)))))}
                    name]))
               sorted-venues))])]]]
     [m/footer {:style {:flex-wrap  "wrap"
                        :gap "0.5rem"}}
      [button/button
       {:aria-label "Close"
        :style      {:flex   1}
        :on-click   #(rf/dispatch [:close-modal id])}
       [:span "Cancel"]]
      [button/button
       {:class    "is-success"
        :style    {:flex   1}
        :on-click #(rf/dispatch [:filter-state (dissoc state :search) id])}
       [:span "Confirm"]]]]))
